/**
 * The deep link into the NADC help desk.
 *
 * Contract (2026-08-06, shared with `/shared/navbar.js` on the portal):
 *   https://helpdesk.nadc1.net/?app=<slug>&url=<page they were on>
 *
 * `app` skips the "what is this about?" picker; `url` is recorded on the ticket
 * so whoever triages it can see the exact screen. The help desk drops a `url`
 * from outside nadc1.net, so there is no point sending one.
 *
 * Kept here rather than inlined at the call site: the picker matches `app`
 * against the portal's apps table, and a typo silently falls back to the
 * generic picker instead of erroring, which is exactly the sort of bug nobody
 * reports. Since 2026-08-31 there is ONE caller — the Guide's general-help
 * panel, which the More menu's Help entry opens — rather than a rail button
 * and a More card that could drift apart.
 *
 * 2026-10-09: a second caller, the NADC apps button's Get Help. It replaces
 * the shared bar's Get Help (gone with the bar), which built this same link.
 */
export function helpdeskUrl(currentHref: string = window.location.href): string {
  const params = new URLSearchParams({ app: 'demoops', url: currentHref });

  return `https://helpdesk.nadc1.net/?${params.toString()}`;
}
